module.exports = __webpack_public_path__ + "static/media/image-not-found.87b4129c.jpg";